(()=>{
'use strict';
const esc=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function render(items){
 if(!items?.length)return '';
 const group=duplicate=>`<ul class="home-logo-strip__group"${duplicate?' aria-hidden="true"':''}>${items.map(item=>`<li class="home-logo-strip__item"><a class="home-scene-label" href="${esc(item.href)}" aria-label="${esc(item.label||item.name)}"${duplicate?' tabindex="-1"':''} draggable="false"><img src="${esc(item.src)}" alt="" width="26" height="26" decoding="async" draggable="false"><span>${esc(item.name)}</span></a></li>`).join('')}</ul>`;
 return `<section id="scene-strip" class="home-logo-strip" aria-label="Shopping benefits and service policies" data-topology="service-strip"><div class="home-logo-strip__viewport"><div class="home-logo-strip__track">${group(false)}${group(true)}</div></div><button type="button" class="home-logo-strip__toggle" aria-label="Pause service scrolling" aria-pressed="false"><svg class="logo-pause" viewBox="0 0 20 20" aria-hidden="true"><path d="M5 3h3v14H5zm7 0h3v14h-3z"/></svg><svg class="logo-play" viewBox="0 0 20 20" aria-hidden="true"><path d="M5 2v16l12-8z"/></svg></button></section>`;
}
let instance=null;
const saved={position:0,paused:false};
function mount(){
 const root=document.querySelector('.home-logo-strip');
 if(instance?.root===root)return;
 instance?.destroy();instance=null;if(!root)return;
 const viewport=root.querySelector('.home-logo-strip__viewport'),groups=[...root.querySelectorAll('.home-logo-strip__group')],button=root.querySelector('.home-logo-strip__toggle');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'),hoverCapable=matchMedia('(hover: hover)');
 const abort=new AbortController(),opts={signal:abort.signal};
 let position=saved.position,paused=saved.paused,hovered=false,focused=false,visible=false,loopWidth=0,frame=0,lastTime=0,pointer=null,suppressClick=false;
 const remember=()=>{saved.position=loopWidth?viewport.scrollLeft%loopWidth:viewport.scrollLeft;saved.paused=paused;};
 const canRun=()=>!paused&&!hovered&&!focused&&!reduced.matches&&visible&&!document.hidden&&loopWidth>0;
 function tick(time){
  frame=0;if(!canRun()){lastTime=0;return;}
  if(lastTime){position=(position+Math.min(time-lastTime,64)*.025)%loopWidth;viewport.scrollLeft=position;}
  lastTime=time;frame=requestAnimationFrame(tick);
 }
 function playback(){
  button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?'Resume service scrolling':'Pause service scrolling');
  root.classList.toggle('is-paused',paused);
  cancelAnimationFrame(frame);frame=0;lastTime=0;
  if(canRun())frame=requestAnimationFrame(tick);
 }
 function measure(){
  const width=viewport.clientWidth;
  groups.forEach(group=>{if(group.style.minWidth!==width+'px')group.style.minWidth=width+'px';});
  loopWidth=groups[0].getBoundingClientRect().width;
  position=loopWidth?position%loopWidth:0;viewport.scrollLeft=position;playback();
 }
 root.addEventListener('mouseenter',()=>{if(hoverCapable.matches){hovered=true;playback();}},opts);
 root.addEventListener('mouseleave',()=>{hovered=false;playback();},opts);
 root.addEventListener('focusin',event=>{
  const link=event.target.closest('a');focused=Boolean(link);position=viewport.scrollLeft;playback();
  if(link)requestAnimationFrame(()=>{
   if(!root.isConnected||document.activeElement!==link)return;
   const bounds=viewport.getBoundingClientRect(),item=link.getBoundingClientRect(),padding=18;
   if(item.left<bounds.left+padding)viewport.scrollLeft-=bounds.left+padding-item.left;
   else if(item.right>bounds.right-padding)viewport.scrollLeft+=item.right-bounds.right+padding;
   position=viewport.scrollLeft;remember();
  });
 },opts);
 root.addEventListener('focusout',event=>{focused=Boolean(event.relatedTarget&&root.contains(event.relatedTarget)&&event.relatedTarget.closest('a'));position=viewport.scrollLeft;playback();},opts);
 button.addEventListener('click',()=>{paused=!paused;position=viewport.scrollLeft;remember();playback();},opts);
 viewport.addEventListener('pointerdown',event=>{
  if(event.pointerType==='mouse')return;
  pointer={x:event.clientX,y:event.clientY};suppressClick=false;paused=true;position=viewport.scrollLeft;remember();playback();
 },{...opts,passive:true});
 viewport.addEventListener('pointermove',event=>{if(pointer&&Math.abs(event.clientX-pointer.x)>8)suppressClick=true;},{...opts,passive:true});
 viewport.addEventListener('pointerup',()=>{pointer=null;position=viewport.scrollLeft;remember();},{...opts,passive:true});
 viewport.addEventListener('pointercancel',()=>{pointer=null;suppressClick=true;position=viewport.scrollLeft;remember();},{...opts,passive:true});
 viewport.addEventListener('scroll',()=>{if(!canRun()){position=viewport.scrollLeft;remember();}},{...opts,passive:true});
 viewport.addEventListener('click',event=>{
  if(suppressClick){event.preventDefault();event.stopPropagation();suppressClick=false;return;}
  remember();
 },{...opts,capture:true});
 viewport.addEventListener('wheel',event=>{if(Math.abs(event.deltaX)>0){paused=true;position=viewport.scrollLeft;playback();}},{...opts,passive:true});
 document.addEventListener('visibilitychange',playback,opts);
 reduced.addEventListener('change',()=>{position=viewport.scrollLeft;measure();},opts);
 const resize=new ResizeObserver(measure);resize.observe(viewport);resize.observe(groups[0]);
 const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;playback();});observer.observe(root);
 instance={root,destroy(){remember();cancelAnimationFrame(frame);resize.disconnect();observer.disconnect();abort.abort();}};
 measure();
 Promise.all([...groups[0].querySelectorAll('img')].map(image=>image.decode().catch(()=>{}))).then(()=>{if(root.isConnected)measure();});
 document.fonts.ready.then(()=>{if(root.isConnected)measure();});
}
window.ACTICLEAR_LOGO_STRIP={render};
const main=document.getElementById('main');if(main)new MutationObserver(mount).observe(main,{childList:true});
mount();
})();
